export default __webpack_public_path__ + "static/buy-a0aed9090c68dd933c492d5b17c98020.svg";